<template>
  <div id="app">
    <Ayoscon />
  </div>
</template>

<script>
import Ayoscon from './components/onepage.vue'

export default {
  name: 'app',
  components: {
    Ayoscon
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
